import { render, staticRenderFns } from "./BalaCreate.vue?vue&type=template&id=2ab0fc8d&scoped=true"
import script from "./BalaCreate.vue?vue&type=script&lang=js"
export * from "./BalaCreate.vue?vue&type=script&lang=js"
import style0 from "./BalaCreate.vue?vue&type=style&index=0&id=2ab0fc8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab0fc8d",
  null
  
)

export default component.exports